import { render, staticRenderFns } from "./courseCenter.vue?vue&type=template&id=4d950178&scoped=true"
import script from "./courseCenter.vue?vue&type=script&lang=js"
export * from "./courseCenter.vue?vue&type=script&lang=js"
import style0 from "./courseCenter.vue?vue&type=style&index=0&id=4d950178&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d950178",
  null
  
)

export default component.exports